import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonDatetime, PopoverController } from '@ionic/angular';
import { format, utcToZonedTime } from 'date-fns-tz';

@Component({
  standalone: false,
    selector: 'app-datetime',
    templateUrl: './datetime.component.html',
    styleUrls: ['./datetime.component.scss'],
})
export class DatetimeComponent implements OnInit {
    @ViewChild('datetime', { static: true }) datetime: IonDatetime;

    @Input() dateTimeIsoString: string;
    @Input() presentation: any;

    dateTimeValue: string;
    isActive: boolean;
    constructor(
        private popoverController: PopoverController
    ) { }

    ngOnInit() {
        this.dateTimeValue = this.getTimeToDisplay();

        if (this.presentation) {
            this.datetime.presentation = this.presentation;
        }
    }

    changeStartDate(ev) {
        this.dateTimeIsoString = ev.detail.value;
    }

    confirm() {
        this.popoverController.dismiss(this.dateTimeIsoString);
    }

    cancel() {
        this.popoverController.dismiss();
    }

    private getTimeToDisplay() {
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const zonedTime = utcToZonedTime(new Date(this.dateTimeIsoString), userTimeZone);
        return format(zonedTime, "yyyy-MM-dd'T'HH:mmXXX", { timeZone: userTimeZone });
    }

}
